import { useEffect, useState } from "react";
import quantaLogo from "../assets/quanta.png";
import { loadingService } from "../services/loadingService";

export default function GlobalLoadingOverlay() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return loadingService.subscribe((value) => setIsLoading(value));
  }, []);

  if (!isLoading) return null;

  return (
    <div style={styles.backdrop} role="status" aria-live="polite" aria-label="Loading">
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <img src={quantaLogo} alt="Loading" style={styles.logo} />
          <span style={styles.ring}></span>
        </div>
        <div style={styles.title}>Please wait</div>
        <div style={styles.text}>Loading your ERP data...</div>
        <div style={styles.progressTrack}>
          <div style={styles.progressBar}></div>
        </div>
      </div>
      <style>{`
        @keyframes vrgSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes vrgPulse { 0%, 100% { opacity: .45; transform: scale(.96); } 50% { opacity: 1; transform: scale(1.04); } }
        @keyframes vrgSlide { 0% { transform: translateX(-100%); } 100% { transform: translateX(260%); } }
      `}</style>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(15, 23, 42, 0.35)",
    backdropFilter: "blur(3px)",
  },
  card: {
    width: 260,
    minHeight: 210,
    borderRadius: 22,
    padding: "26px 24px 22px",
    background: "rgba(255, 255, 255, 0.96)",
    boxShadow: "0 24px 70px rgba(15, 23, 42, 0.28)",
    border: "1px solid rgba(255, 255, 255, 0.7)",
    textAlign: "center",
  },
  logoWrap: {
    position: "relative",
    width: 92,
    height: 92,
    margin: "0 auto 14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    maxWidth: 58,
    maxHeight: 58,
    objectFit: "contain",
    animation: "vrgPulse 1.4s ease-in-out infinite",
  },
  ring: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    border: "4px solid #e6eef8",
    borderTopColor: "#0d6efd",
    borderRightColor: "#20c997",
    animation: "vrgSpin .8s linear infinite",
  },
  title: {
    fontSize: 16,
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: 4,
  },
  text: {
    fontSize: 12,
    color: "#64748b",
    marginBottom: 16,
  },
  progressTrack: {
    height: 7,
    borderRadius: 999,
    background: "#e9eef5",
    overflow: "hidden",
  },
  progressBar: {
    width: "42%",
    height: "100%",
    borderRadius: 999,
    background: "linear-gradient(90deg,#0b4f4a,#0f766e)",
    animation: "vrgSlide 1.05s ease-in-out infinite",
  },
};
